var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { ScrollListPage } from "@common/enums/base";
import http, { Q, Api } from "@http";
import { observable, action, runInAction } from "mobx";
import LoadingData from "../common/loadingData";
var DashboardStore = /** @class */ (function () {
    function DashboardStore() {
        this.scheduledWoList = new LoadingData([]);
        this.serviceRequestWorkOrders = new LoadingData([]);
        this.ratingWoList = new LoadingData([]);
        this.scheduledWoListCurrentPage = 1;
        this.srWorkOrdersCurrentPage = 1;
        this.recurrentRatingNewCurrentPage = 1;
        this.recurrentRatingCurrentPage = 1;
        this.pageSize = 10;
        this.hasServiceRequestAbModule = true;
        this.woDateilInfo = {};
        this.isNewRating = false;
        this.confirmOnSiteRateReasonList = [];
        this.confirmContactCenterRateReasonList = [];
        this.confirmWoNotCompletedReasonList = [];
        this.isSubmitting = false;
        this.isSuccess = true;
        this.reasonSelcet = -1;
        this.recommendScore = -1;
        this.recommendComment = "";
        this.showRecommendComment = false;
        this.isAlertShow = false;
    }
    DashboardStore.prototype.getScheduledWoList = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            page: page || this.scheduledWoListCurrentPage,
                            pageSize: this.pageSize,
                        };
                        if (!page && this.scheduledWoList.isNoData) {
                            return [2 /*return*/];
                        }
                        this.scheduledWoList.setLoading();
                        return [4 /*yield*/, this.api().getScheduledWoList(params)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (!data || !Array.isArray(data.WoCountItems)) {
                                _this.scheduledWoList.setUnLoading();
                                return;
                            }
                            var noNextData = data.WoCountItems.length < _this.pageSize;
                            if (noNextData && _this.scheduledWoList.data.length > 0) {
                                data.WoCountItems.push({
                                    isEnd: true
                                });
                                _this.scheduledWoList.setIsNoData(true);
                            }
                            if (page) {
                                _this.scheduledWoListCurrentPage = ScrollListPage.SecondPage;
                                _this.scheduledWoList.setLoadedData(data.WoCountItems);
                            }
                            else {
                                _this.scheduledWoListCurrentPage++;
                                _this.scheduledWoList.setLoadedData(__spreadArrays(_this.scheduledWoList.data, data.WoCountItems));
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardStore.prototype.getHasServiceRequestAbModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.api()
                    .hasServiceRequestAbModule()
                    .then(function (data) {
                    runInAction(function () {
                        _this.hasServiceRequestAbModule = data;
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    DashboardStore.prototype.getServiceRequestWorkOrders = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            page: page || this.srWorkOrdersCurrentPage,
                            pageSize: this.pageSize,
                        };
                        if (!page && this.serviceRequestWorkOrders.isNoData) {
                            return [2 /*return*/];
                        }
                        this.serviceRequestWorkOrders.setLoading();
                        return [4 /*yield*/, this.api().getServiceRequestWorkOrders(params)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (!data || !Array.isArray(data.serviceRequestItems)) {
                                _this.serviceRequestWorkOrders.setUnLoading();
                                return;
                            }
                            var noNextData = data.serviceRequestItems.length < _this.pageSize;
                            if (noNextData) {
                                _this.serviceRequestWorkOrders.setIsNoData(true);
                            }
                            if (page) {
                                _this.srWorkOrdersCurrentPage = ScrollListPage.SecondPage;
                                _this.serviceRequestWorkOrders.setLoadedData(data.serviceRequestItems);
                            }
                            else {
                                _this.srWorkOrdersCurrentPage++;
                                _this.serviceRequestWorkOrders.setLoadedData(__spreadArrays(_this.serviceRequestWorkOrders.data, data.serviceRequestItems));
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardStore.prototype.getRatingWoList = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var isAbModule, isNewRating, data, params, params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        !this.ratingWoList.isNoData && this.ratingWoList.setLoading();
                        return [4 /*yield*/, this.api().getRatingABModule()];
                    case 1:
                        isAbModule = _a.sent();
                        isNewRating = isAbModule === true || isAbModule === "true" || isAbModule === "True";
                        data = null;
                        if (!isNewRating) return [3 /*break*/, 3];
                        params = {
                            page: page || this.recurrentRatingNewCurrentPage,
                            pageSize: this.pageSize,
                        };
                        return [4 /*yield*/, this.api().getRecurrentRatingNew(params)];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        params = {
                            page: page || this.recurrentRatingCurrentPage,
                            pageSize: this.pageSize,
                        };
                        return [4 /*yield*/, this.api().getRecurrentRating(params)];
                    case 4:
                        data = _a.sent();
                        _a.label = 5;
                    case 5:
                        runInAction(function () {
                            // Advance before the bad-payload check, matching getRecurrentRating: the value
                            // handed to handleFirstPageNoData is the post-increment one.
                            _this.setRatingCurrentPage(isNewRating, _this.ratingCurrentPage(isNewRating) + 1);
                            if (!data || !Array.isArray(data.items)) {
                                _this.ratingWoList.setUnLoading();
                                _this.handleFirstPageNoData(page || _this.ratingCurrentPage(isNewRating));
                                return;
                            }
                            var noNextData = data.items.length < _this.pageSize;
                            if (noNextData) {
                                _this.ratingWoList.setIsNoData(true);
                            }
                            // Write to the rating cursor, not the Service Request one: they drive separate
                            // lists and sharing a cursor broke both. Already advanced above, so the append
                            // branch leaves it as is.
                            if (page) {
                                _this.setRatingCurrentPage(isNewRating, ScrollListPage.SecondPage);
                                _this.ratingWoList.setLoadedData(data.items);
                            }
                            else {
                                _this.ratingWoList.setLoadedData(__spreadArrays(_this.ratingWoList.data, data.items));
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** The rating list keeps one cursor per generation; pick the live one. */
    DashboardStore.prototype.ratingCurrentPage = function (isNewRating) {
        return isNewRating ? this.recurrentRatingNewCurrentPage : this.recurrentRatingCurrentPage;
    };
    DashboardStore.prototype.setRatingCurrentPage = function (isNewRating, value) {
        if (isNewRating) {
            this.recurrentRatingNewCurrentPage = value;
        }
        else {
            this.recurrentRatingCurrentPage = value;
        }
    };
    DashboardStore.prototype.handleFirstPageNoData = function (page) {
        if (page === ScrollListPage.FirstPage) {
            this.ratingWoList.setLoadedData([]);
        }
    };
    DashboardStore.prototype.clear = function () {
        this.scheduledWoList = new LoadingData([]);
        this.serviceRequestWorkOrders = new LoadingData([]);
        this.ratingWoList = new LoadingData([]);
        this.woDateilInfo = {};
        this.confirmOnSiteRateReasonList = [];
        this.confirmContactCenterRateReasonList = [];
        this.confirmWoNotCompletedReasonList = [];
        this.scheduledWoListCurrentPage = 1;
        this.srWorkOrdersCurrentPage = 1;
        this.recurrentRatingNewCurrentPage = 1;
        this.recurrentRatingCurrentPage = 1;
    };
    DashboardStore.prototype.clearRatingList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.recurrentRatingNewCurrentPage = 1;
                this.recurrentRatingCurrentPage = 1;
                this.ratingWoList = new LoadingData([]);
                return [2 /*return*/];
            });
        });
    };
    DashboardStore.prototype.getRecurrentRating = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            page: page || this.recurrentRatingCurrentPage,
                            pageSize: this.pageSize,
                        };
                        !this.ratingWoList.isNoData && this.ratingWoList.setLoading();
                        return [4 /*yield*/, this.api().getRecurrentRating(params)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.recurrentRatingCurrentPage++;
                            if (!data || !Array.isArray(data.items)) {
                                _this.ratingWoList.setUnLoading();
                                _this.handleFirstPageNoData(page || _this.recurrentRatingCurrentPage);
                                return;
                            }
                            var noNextData = data.items.length < _this.pageSize;
                            if (noNextData) {
                                _this.ratingWoList.setIsNoData(true);
                            }
                            var tempPage = page || _this.recurrentRatingCurrentPage;
                            if (tempPage === ScrollListPage.FirstPage) {
                                _this.ratingWoList.setLoadedData(data.items);
                                return false;
                            }
                            _this.ratingWoList.setLoadedData(__spreadArrays(_this.ratingWoList.data, data.items));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardStore.prototype.getWoDateilInfo = function (WOId, linkObjectType, isNewUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getWoDateil(WOId, linkObjectType, isNewUrl);
                        this.isNewRating = isNewUrl;
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.woDateilInfo = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    DashboardStore.prototype.getConfirmOnSiteRateReasonList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getConfirmOnSiteRateReasonList({
                            isReactive: this.woDateilInfo.isReactive,
                            woDepartmentId: this.woDateilInfo.WODepartmentId
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.confirmOnSiteRateReasonList = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardStore.prototype.getConfirmContactCenterRateReasonList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getConfirmContactCenterRateReasonList({
                            isReactive: this.woDateilInfo.isReactive,
                            woDepartmentId: this.woDateilInfo.WODepartmentId
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.confirmContactCenterRateReasonList = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardStore.prototype.getConfirmWoNotCompletedReasonList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getConfirmWoNotCompletedReasonList({
                            isReactive: this.woDateilInfo.isReactive,
                            woDepartmentId: this.woDateilInfo.WODepartmentId
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.confirmWoNotCompletedReasonList = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardStore.prototype.postRatingWoResult = function (ratingWoResult) {
        return this.api().postRatingWoResult(this.woDateilInfo.Id, ratingWoResult);
    };
    DashboardStore.prototype.setSubmittingStatus = function (flag) {
        this.isSubmitting = flag;
    };
    DashboardStore.prototype.setIsSuccess = function (flag) {
        this.isSuccess = flag;
    };
    DashboardStore.prototype.setReasonSelcet = function (idx) {
        this.reasonSelcet = idx;
    };
    DashboardStore.prototype.setRecommendScore = function (i) {
        this.recommendScore = i;
    };
    DashboardStore.prototype.setRecommendComment = function (val) {
        this.recommendComment = val;
    };
    DashboardStore.prototype.setShowRecommendComment = function (f) {
        this.showRecommendComment = f;
    };
    DashboardStore.prototype.setAlertShow = function (f) {
        this.isAlertShow = f;
    };
    DashboardStore.prototype.ratingWoResultOld = function (WOId, linkObjectType, rateModel) {
        return this.api().ratingWoResultOld(WOId, linkObjectType, rateModel);
    };
    DashboardStore.prototype.api = function () {
        return {
            getScheduledWoList: function (params) {
                return Q(http.post("RSP/Dashboard/GetScheduledWoList", params));
            },
            getServiceRequestWorkOrders: function (params) {
                return Q(http.get("RSP/ServiceRequest/GetServiceRequestWorkOrders?page=" + params.page + "&pageSize=" + params.pageSize));
            },
            getRecurrentRatingNew: function (params) {
                return Q(http.get("RSP/Dashboard/RecurrentRatingNew?page=" + params.page + "&pageSize=" + params.pageSize));
            },
            getRatingABModule: function () {
                return Q(http.get("/RSP/Dashboard/RatingABModule"));
            },
            getRecurrentRating: function (params) {
                return Q(http.get("RSP/Dashboard/recurrentRating?page=" + params.page + "&pageSize=" + params.pageSize));
            },
            getWoDateil: function (WOId, linkObjectType, isNewUrl) {
                var objectType = linkObjectType === '1' ? 'true' : 'false';
                var argSecond = isNewUrl ? linkObjectType : objectType;
                return Q(http.post("RSP/Request/" + WOId + "/" + argSecond + "/" + (isNewUrl ? 'WoDateilNew' : 'WoDateil')));
            },
            getConfirmOnSiteRateReasonList: function (reasonListParams) {
                return Q(http.post("RSP/Request/GetConfirmOnSiteRateReasonList", reasonListParams));
            },
            getConfirmContactCenterRateReasonList: function (reasonListParams) {
                return Q(http.post("RSP/Request/GetConfirmContactCenterRateReasonList", reasonListParams));
            },
            getConfirmWoNotCompletedReasonList: function (reasonListParams) {
                return Q(http.post("RSP/Request/GetConfirmWoNotCompletedReasonList", reasonListParams));
            },
            postRatingWoResult: function (WOId, ratingWoResult) {
                return Q(http.post("RSP/Request/" + WOId + "/RatingWoResultNew", ratingWoResult));
            },
            hasServiceRequestAbModule: function () {
                return Q(http.post("/RSP/Dashboard/IsABServiceRequest"));
            },
            ratingWoResultOld: function (WOId, linkObjectType, rateModel) {
                return Q(http.post("RSP/Request/" + WOId + "/" + linkObjectType + "/RatingWoResult", rateModel, __assign({}, Api.withForm)));
            },
        };
    };
    __decorate([
        observable
    ], DashboardStore.prototype, "scheduledWoList", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "serviceRequestWorkOrders", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "ratingWoList", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "scheduledWoListCurrentPage", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "srWorkOrdersCurrentPage", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "recurrentRatingNewCurrentPage", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "recurrentRatingCurrentPage", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "hasServiceRequestAbModule", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "getScheduledWoList", null);
    __decorate([
        action
    ], DashboardStore.prototype, "getHasServiceRequestAbModule", null);
    __decorate([
        action
    ], DashboardStore.prototype, "getServiceRequestWorkOrders", null);
    __decorate([
        action
    ], DashboardStore.prototype, "getRatingWoList", null);
    __decorate([
        action
    ], DashboardStore.prototype, "clear", null);
    __decorate([
        action
    ], DashboardStore.prototype, "clearRatingList", null);
    __decorate([
        action
    ], DashboardStore.prototype, "getRecurrentRating", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "woDateilInfo", void 0);
    __decorate([
        observable
    ], DashboardStore.prototype, "isNewRating", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "getWoDateilInfo", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "confirmOnSiteRateReasonList", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "getConfirmOnSiteRateReasonList", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "confirmContactCenterRateReasonList", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "getConfirmContactCenterRateReasonList", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "confirmWoNotCompletedReasonList", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "getConfirmWoNotCompletedReasonList", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "isSubmitting", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setSubmittingStatus", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "isSuccess", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setIsSuccess", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "reasonSelcet", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setReasonSelcet", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "recommendScore", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setRecommendScore", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "recommendComment", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setRecommendComment", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "showRecommendComment", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setShowRecommendComment", null);
    __decorate([
        observable
    ], DashboardStore.prototype, "isAlertShow", void 0);
    __decorate([
        action
    ], DashboardStore.prototype, "setAlertShow", null);
    __decorate([
        action
    ], DashboardStore.prototype, "ratingWoResultOld", null);
    return DashboardStore;
}());
export default DashboardStore;
